module.exports = __webpack_public_path__ + "fonts/GothamSSm-Medium.4f37bc46.woff";